import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

const WhatsAppButton = () => {
  const phoneNumber = "393358344557";
  const message = encodeURIComponent("Ciao! Sono interessato ai vostri servizi di gestione affitti brevi Premium a Milano. Potreste darmi maggiori informazioni?");

  const handleClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'whatsapp_click', {
        event_category: 'Contact',
        event_label: 'WhatsApp Button'
      });
    }
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <motion.button
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 3, type: 'spring', stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleClick}
      className="fixed bottom-6 left-6 z-40 bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-lg transition-colors duration-200 group"
      aria-label="Contattaci su WhatsApp"
    >
      <SafeIcon icon={FiMessageCircle} className="h-6 w-6" />
      <div className="absolute bottom-full left-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        <div className="bg-brand-blue text-white text-sm px-3 py-1 rounded-lg whitespace-nowrap border border-brand-gold/30">
          Chatta con il Team
        </div>
        <div className="w-2 h-2 bg-brand-blue transform rotate-45 absolute top-full left-4 -mt-1 border-r border-b border-brand-gold/30"></div>
      </div>
    </motion.button>
  );
};

export default WhatsAppButton;